module.exports = __webpack_public_path__ + "img/zhongxinGH1.24a7f211.png";